// Internalizado de @mandae/ng-api 2.13.7 na remoção da dependência.
// Mantidos apenas os métodos usados pelo webapp.
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConfig } from '../api-config';
import { ContactProfile, CustomerContact } from '../models/customer';

@Injectable({
  providedIn: 'root'
})
export class CustomerContactsApiService {

  constructor(private http: HttpClient, private config: APIConfig) { }

  /**
   * Cria um novo contato associado ao cliente
   *
   * @param customerId ID do cliente a receber o novo contato
   * @param contact dados de contato a receber
   */
  public createCustomerContact(customerId: number, contact: CustomerContact): Observable<CustomerContact> {
    return this.http.put<CustomerContact>(`${this.config.customerApiUrl}/clientes/${customerId}/contatos`, contact);
  }

  /**
   * Obtém a lista de contatos de um cliente
   *
   * @param customerId ID do cliente para obter os contatos
   * @param profile Perfil de contato para filtrar a busca
   */
  public getCustomerContacts(customerId: number, profile?: ContactProfile): Observable<CustomerContact[]> {
    // HttpParams e imutavel: set() retorna nova instancia e precisa ser reatribuido.
    // Na lib original o retorno era descartado e o filtro nunca ia na request.
    let params = new HttpParams();
    if (profile) {
      params = params.set('perfil', profile);
    }

    return this.http.get<CustomerContact[]>(`${this.config.customerApiUrl}/clientes/${customerId}/contatos`, {
      params,
    });
  }

  /**
   * Atualiza os dados de um contato associado a um cliente
   *
   * @param customerId ID do cliente associado ao contato
   * @param contactId ID do contato a ser alterado
   * @param contact dados a serem alterados
   */
  public updateCustomerContact(customerId: number, contactId: number, contact: CustomerContact) {
    return this.http.post<CustomerContact>(`${this.config.customerApiUrl}/clientes/${customerId}/contatos/${contactId}`, contact);
  }

  /**
   * Deleta um contato da lista de contatos de um cliente
   *
   * @param customerId ID do cliente associado ao contato
   * @param contactId ID do contato
   */
  public deleteCustomerContact(customerId: number, contactId: number): Observable<CustomerContact> {
    return this.http.delete<CustomerContact>(`${this.config.customerApiUrl}/clientes/${customerId}/contatos/${contactId}`);
  }

}
